import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography, Button, Table } from "antd";
import { BarChartOutlined } from "@ant-design/icons";

import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const cardStyle2 = {
  height: 200,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard7_3 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [data7_3_10, _data7_3_10] = useState();
  const [data7_3_11, _data7_3_11] = useState();

  const [dataBar7_3_1, _dataBar7_3_1] = useState();
  const [dataBar7_3_2, _dataBar7_3_2] = useState();
  const [dataBar7_3_3, _dataBar7_3_3] = useState();
  const [dataBar7_3_4, _dataBar7_3_4] = useState();

  useEffect(() => {
    Find_barData("bar7_3_1");
    Find_barData("bar7_3_2");
    Find_barData("bar7_3_3");
    // Find_barData("bar7_3_4");

    Find_Data("data7_3_10");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db7_3", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = i.name + 543;

            if (order == "bar7_3_1") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_2") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_3") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_4") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar7_3_1") {
          _dataBar7_3_1(Tb1);
        } else if (order == "bar7_3_2") {
          _dataBar7_3_2(Tb1);
        } else if (order == "bar7_3_3") {
          _dataBar7_3_3(Tb1);
        } else if (order == "bar7_3_4") {
          _dataBar7_3_4(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_Data = order => {
    axios
      .post(xURL + "db_data_db7_3", {
        order: order
      })
      .then(result => {
        //console.log(result.data);
        if (order == "data7_3_10") {
          _data7_3_10(result.data);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const columns7_3_5 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_5 = [
    {
      key: "1",
      c1: "จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS",
      c2: "148"
    },
    {
      key: "2",
      c1: "อาจารย์",
      c2: "7"
    },
    {
      key: "3",
      c1: "อัตราส่วน",
      c2: "21.14"
    }
  ];

  const columns7_3_6 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ปี 2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_6 = [
    {
      key: "1",
      c1: "จำนวนอาจารย์ทั้งหมด",
      c2: "7"
    },
    {
      key: "2",
      c1: "จำนวนอาจารย์ที่มีตำแหน่งวิชาการ",
      c2: "6"
    },
    {
      key: "3",
      c1: "จำนวนร้อยละ อาจารย์มีตำแหน่งวิชาการ",
      c2: "85.714286"
    }
  ];

  const columns7_3_8 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ปี 2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_8 = [
    {
      key: "1",
      c1: "สายสนับสนุนการวิจัย",
      c2: "85.2"
    },
    {
      key: "2",
      c1: "สายปฏิบัติการทั่วไป",
      c2: "95.3"
    }
  ];

  const columns7_3_9 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_9 = [
    {
      key: "1",
      c1: "CMCB",
      c2: "85.62"
    },
    {
      key: "2",
      c1: "IDSU",
      c2: "93.2"
    },
    {
      key: "3",
      c1: "NINE",
      c2: "95.5"
    },
    {
      key: "4",
      c1: "ADMIN",
      c2: "90.8"
    },
    {
      key: "5",
      c1: "SHSR",
      c2: "92.1"
    },
    {
      key: "6",
      c1: "RSO",
      c2: "88.8"
    }
  ];

  const columns7_3_10 = [
    {
      title: "",
      dataIndex: "metric",
      key: "metric",
      align: "left"
    },
    {
      title: "",
      dataIndex: "metric2",
      key: "metric2",
      align: "center"
    },
    {
      title: "64",
      dataIndex: "y64",
      key: "y64",
      align: "center"
    },
    {
      title: "65",
      dataIndex: "y65",
      key: "y65",
      align: "center"
    },
    {
      title: "66",
      dataIndex: "y66",
      key: "y66",
      align: "center"
    },
    {
      title: "67",
      dataIndex: "y67",
      key: "y67",
      align: "center"
    },
    {
      title: "68",
      dataIndex: "y68",
      key: "y68",
      align: "center"
    }
  ];

  const columns7_3_11 = [
    {
      title: "",
      dataIndex: "metric",
      key: "metric",
      align: "left"
    },
    {
      title: "64",
      dataIndex: "y64",
      key: "y64",
      align: "center"
    },
    {
      title: "65",
      dataIndex: "y65",
      key: "y65",
      align: "center"
    },
    {
      title: "66",
      dataIndex: "y66",
      key: "y66",
      align: "center"
    },
    {
      title: "67",
      dataIndex: "y67",
      key: "y67",
      align: "center"
    },
    {
      title: "68",
      dataIndex: "y68",
      key: "y68",
      align: "center"
    }
  ];

  const highlightRows = [
    "จำนวน อจ. ต่อ จำนวน นศ.",
    "จำนวน อจ. + นวจ. ต่อ จำนวน นศ."
  ];

  const columns7_3_12 = [
    {
      title: "ปีการศึกษา",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    },
    {
      title: "2565",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "2566",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "2567",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    },
    {
      title: "รวม 2565-2568",
      dataIndex: "c6",
      key: "c6",
      align: "center"
    }
  ];

  const data7_3_12 = [
    {
      key: "1",
      c1: "จำนวน นศ.",
      c2: "20",
      c3: "15",
      c4: "15",
      c5: "20",
      c6: "70"
    },
    {
      key: "2",
      c1: "จำนวน อจ.",
      c2: "7",
      c3: "7",
      c4: "7",
      c5: "7",
      c6: "7"
    },
    {
      key: "3",
      c1: "จำนวน อจ. ต่อ จำนวน นศ.",
      c2: "1:2.85",
      c3: "1:2.14",
      c4: "1:2.14",
      c5: "1:2.85",
      c6: "1:1.10"
    },
    {
      key: "4",
      c1: "จำนวน อจ. + นวจ.",
      c2: "23",
      c3: "23",
      c4: "23",
      c5: "23",
      c6: "23"
    },
    {
      key: "5",
      c1: "จำนวน อจ. + นวจ. ต่อ จำนวน นศ.",
      c2: "1:0.87",
      c3: "1:0.65",
      c4: "1:0.65",
      c5: "1:0.87",
      c6: "1:3.04"
    }
  ];

  const columns7_3_13 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ปี 2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_13 = [
    {
      key: "1",
      c1: "กลุ่มสนับสนุนการวิจัย",
      c2: "136"
    },
    {
      key: "2",
      c1: "กลุ่มปฏิบัติการทั่วไป",
      c2: "51"
    },
    {
      key: "3",
      c1: "กลุ่มวิชาการ",
      c2: "22"
    },
    {
      key: "4",
      c1: "ข้อมูล ณ. วันที่ 30 มิ.ย. 68",
      c2: "209"
    }
  ];

  const columns7_3_14 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      key: "c2",
      align: "center",
      children: [
        {
          title: "จำนวนที่ขอ : จำนวนที่ได้",
          dataIndex: "c2_1",
          key: "c2_1",
          align: "center"
        },
        {
          title: "ร้อยละ",
          dataIndex: "c2_2",
          key: "c2_2",
          align: "center"
        }
      ]
    }
  ];

  const data7_3_14 = [
    {
      key: "1",
      c1: "อาจารย์",
      c2_1: "2:0",
      c2_2: "0"
    },
    {
      key: "2",
      c1: "นักวิจัย",
      c2_1: "5:0",
      c2_2: "0"
    },
    {
      key: "3",
      c1: "สนับสนุนงานวิจัย",
      c2_1: "1:1",
      c2_2: "100"
    },
    {
      key: "4",
      c1: "สนับสนุนงานวิจัย",
      c2_1: "1:0",
      c2_2: "0"
    }
  ];

  const columns7_3_15 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: (text, record) => {
        const isHeader = text === "สายวิชาการ" || text === "สายสนับสนุน";

        return (
          <div
            style={{
              fontWeight: isHeader ? "bold" : "normal",
              textAlign: isHeader ? "left" : "left"
            }}
          >
            {text}
          </div>
        );
      }
    },
    {
      title: "ปี 2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "% ได้ต่อสัญญาใหม่",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    }
  ];

  const data7_3_15 = [
    {
      key: "1",
      c1: "สายวิชาการ",
      c2: "",
      c3: ""
    },
    {
      key: "2",
      c1: "นักวิจัย",
      c2: "90.33",
      c3: "100"
    },
    {
      key: "3",
      c1: "อาจารย์",
      c2: "-",
      c3: "-"
    },
    {
      key: "4",
      c1: "สายสนับสนุน",
      c2: "",
      c3: ""
    },
    {
      key: "5",
      c1: "สนับสนุนการวิจัย",
      c2: "96.5",
      c3: "100"
    },
    {
      key: "6",
      c1: "ปฏิบัติการทั่วไป",
      c2: "90",
      c3: "100"
    }
  ];

  const columns7_3_18 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_18 = [
    {
      key: "1",
      c1: "อาจารย์",
      c2: "0"
    },
    {
      key: "2",
      c1: "นักวิจัย",
      c2: "0"
    },
    {
      key: "3",
      c1: "สนับสนุนการวิจัย",
      c2: "1"
    },
    {
      key: "4",
      c1: "ปฏิบัติดารทั่วไป",
      c2: "2"
    }
  ];

  const columns7_3_22 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_22 = [
    {
      key: "1",
      c1: "ร้อยละบุคลากรเข้าระบบ CMU IDP",
      c2: "N/A"
    },
    {
      key: "2",
      c1: "ผลการประเมินหัวหน้างาน",
      c2: "96"
    },
    {
      key: "3",
      c1: "ร้อยละผู้บริหารเข้า cmu PFL",
      c2: "ไม่มีผู้เข้าเกณฑ์"
    },
    {
      key: "4",
      c1: "ผลประเมินของผู้บริหารระดับต้นและกลาง",
      c2: "87.17"
    }
  ];

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านบุคลากร
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-1 จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS ต่อนักวิจัย"
          >
            <Barchart dataBar={dataBar7_3_1} order={"bar7_3_1"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-2 จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS Q1 ต่อนักวิจัย"
          >
            <Barchart dataBar={dataBar7_3_2} order={"bar7_3_2"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-3 จำนวนการอ้างอิงผลงานวิจัยต่อนักวิจัย"
          >
            {/* <Barchart dataBar={dataBar7_3_3} order={"bar7_3_3"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div> */}

            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_3/file_7_3_3_จำนวนการอ้างอิงผลงานวิจัยต่อนักวิจัย_SciV.xlsx",
                    "_blank"
                  )}
              >
                จำนวนการอ้างอิงผลงานวิจัยต่อนักวิจัย
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-4 ร้อยละนักวิจัยที่มีตำแหน่งวิชาการ"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_3/file_7_3_4_ร้อยละนักวิจัยที่มีตำแหน่งวิชาการ.xlsx",
                    "_blank"
                  )}
              >
                ร้อยละนักวิจัยที่มีตำแหน่งวิชาการ
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-5 จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS ต่ออาจารย์"
          >
            <Table
              columns={columns7_3_5}
              dataSource={data7_3_5}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-6 ร้อยละอาจารย์ที่มีตำแหน่งวิชาการ"
          >
            <Table
              columns={columns7_3_6}
              dataSource={data7_3_6}
              pagination={false}
              size="small"
              bordered
            />
            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ร้อยละอาจารย์ที่มีตำแหน่งวิชาการ (1 ต.ค. 67 - 30 ก.ย.
              68)
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 4 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-7 ผลประเมินการเรียนการสอนของอาจารย์"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiNTgwZmRiNjQtYzhjNi00ZjUyLWI1ZTctMzFiOGQ3Y2NkMDZjIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                แบบประเมิน อาจารย์
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-8 ผลการประเมินขีดความสามารถบุคลากรสายปฏิบัติการ"
          >
            <Table
              columns={columns7_3_8}
              dataSource={data7_3_8}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 5 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-9 ผลการประเมินการให้บริการและสนับสนุนสายวิชาการ"
          >
            <Table
              columns={columns7_3_9}
              dataSource={data7_3_9}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-10 สัดส่วนจำนวนโครงการและทุนวิจัยต่อนักวิจัย"
          >
            <Table
              columns={columns7_3_10}
              dataSource={data7_3_10}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 6 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-11 ข้อมูลจำนวนนักวิจัยและผลตีพิมพ์แยกตามทิศทางวิจัย"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_3/file_7_3_11ข้อมูลจำนวนนักวิจัยและผลตีพิมพ์แยกตามทิศทางวิจัย.xlsx",
                    "_blank"
                  )}
              >
                ข้อมูลจำนวนนักวิจัยและผลตีพิมพ์แยกตามทิศทางวิจัย
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-12 อัตราส่วนของ นศ. ต่อบุคลากรสายวิชาการ"
          >
            <Table
              columns={columns7_3_12}
              dataSource={data7_3_12}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 7 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-13 จำนวนและอัตรส่วนของบุคลากรสายสับสนุน และสายวิชาการ"
          >
            <Table
              columns={columns7_3_13}
              dataSource={data7_3_13}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-14 ร้อยละบุคลากรที่ได้รับจักสรรอัตรากำลัง ทุกกลุ่ม"
          >
            <Table
              columns={columns7_3_14}
              dataSource={data7_3_14}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 8 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-15 คะแนนประเมินขีดความสามารถของบุคลากรใหม่"
          >
            <Table
              columns={columns7_3_15}
              dataSource={data7_3_15}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-16 ผลประเมินความพึงพอใจของบุคลากร"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                แบบประเมินความพึงพอใจของบุคลากร
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 9 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-17 ผลลัพธ์ด้านความผูกพันของบุคลากรแต่ละกลุ่ม"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ผลลัพธ์ด้านความผูกพันของบุคลากรแต่ละกลุ่ม
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-18 จำนวนบุคลากรที่ลาออกก่อนหมดสัญญา"
          >
            <Table
              columns={columns7_3_18}
              dataSource={data7_3_18}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 10 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-19 ผลประเมินความพึงพอใจของบุคลากรต่อกระบวนการสร้างความผูกพันธ์"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ผลประเมินความพึงพอใจของบุคลากรต่อกระบวนการสร้างความผูกพันธ์
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-20 ความไม่พึงพอใจของบุคลากรต่อการทำงานในสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ความไม่พึงพอใจของบุคลากรต่อการทำงานในสถาบันฯ
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 11 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-21 ผลประเมินความพึงพอใจของบุคลากรต่อกระบวนการพัฒนาบุคลากร"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ผลประเมินความพึงพอใจของบุคลากรต่อกระบวนการพัฒนาบุคลากร
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-22 การเตรียมหัวหน้างานและผู้บริหารในอนาคต"
          >
            <Table
              columns={columns7_3_22}
              dataSource={data7_3_22}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_3;
